import { Factory } from 'rosie';
import '../conversation_item_factory';

Factory.define('AITransferMessage')
  .attr('type', 'AI_TRANSFER');

Factory.define('AITransferWithDefaults')
  .extend('AITransferMessage')
  .attr('detail', {
    channel: 'CHAT',
    rationale: 'Customer requested human assistance',
  })
  .attr('transferType', 'AUTOMATED');


Factory.define('AITransferItemWithDefaults')
  .extend('ConversationItem')
  .attr('content', ['content'], content => Factory.attributes('AITransferWithDefaults', content))
  .attr('initiator', {
    type: 'SYSTEM',
    id: 'SIDEKICK_V2',
  });
